import { Component, Input, OnInit, OnDestroy, Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import * as DocActions from '../../../store/actions/doc.actions';
import * as DocSelectors from '../../../store/selectors/doc.selector';
import { IDocModel } from '../../models/doc.model';
import * as fromApp from '../../../store/app.reducer';
import { IDocDB } from '../doc.component/doc.page';
import { environment } from 'src/environments/environment';
import { FileModel } from '../../models/file.model';


@Injectable({ providedIn: 'root' })
@Component({
    selector: 'app-files-modal',
    templateUrl: './files-modal.component.html',
    styleUrls: ['./files-modal.component.scss'],
    standalone: false
})
export class FilesModalComponent implements OnInit, OnDestroy {
    @Input() docId!: number;
    files: any[] = [];

    private _docSubscription!: Subscription;

    constructor(
        private modalCtrl: ModalController,
        private store: Store<fromApp.AppState>,    // <-- inject store
    ) { }

    ngOnInit() {
        // Dispatch για να φέρουμε το doc
        this.store.dispatch(
            DocActions.getDocById({ payload: { id: this.docId } })
        );

        this._docSubscription = this.store
            .select(DocSelectors.selectDoc)      // διαλέγουμε το state
            .pipe(
                filter((doc): doc is IDocDB  => !!doc),  // μόνο όταν υπάρχει τιμή
                take(1)                                    // μόνο 1 φορά
            )
            .subscribe((doc) => {
                // αν θέλεις, αποθήκευσε και τα files:
                this.files = doc.files || [];
            });
    }

    downloadAttachment(e, file: FileModel): void {
        const filepath = file.localpath;
        const filename = file.filename;
        const timestamp = new Date().getTime();
        const fileUrl = `${environment.apiUrl}/files/
        ${encodeURIComponent(filename)}?filepath=${encodeURIComponent(filepath)}&t=${timestamp}`;

        window.open(fileUrl);
      }

    ngOnDestroy() {
        if (this._docSubscription) {
            this._docSubscription.unsubscribe();
        }
    }

    close() {
        this.modalCtrl.dismiss();
    }
}
